import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=ef16ba10&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef16ba10')) {
      api.createRecord('ef16ba10', component.options)
    } else {
      api.reload('ef16ba10', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=ef16ba10&", function () {
      api.rerender('ef16ba10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29EgEWqTIn6Oz/JS/comp/openstreetmap.vue"
export default component.exports